const performanceDashboard = {
  title: 'Panel de Rendimiento',
  subTitle: 'Resumen de métricas operativas clave',
  supplierSelector: {
    label: 'Elegir Proveedor:',
  },
  acceptDeclineTripsPie: {
    title: 'Viajes Aceptados / Rechazados',
    pies: {
      accept: 'Aceptar',
      decline: 'Rechazar',
    },
  },
  assignmentTypePie: {
    title: 'Tipo de Asignación',
    pies: {
      manual: 'Manual',
      automated: 'Automatizado',
    },
  },
  coverageCapacityChart: {
    title: 'Capacidad de Cobertura',
    bars: {
      capacity: 'Capacidad',
    },
  },
  fleetAcceptanceChart: {
    title: 'Aceptación de la Flota',
    bars: {
      acceptance: 'Aceptación',
    },
  },
  noShowCancelationChart: {
    title: 'Tasas de Inasistencia y Cancelación',
    bars: {
      noShow: 'Inasistencia',
      cancelation: 'Cancelación',
    },
  },
  onTimePerformanceChart: {
    title: 'Puntualidad',
    bars: {
      onTime: 'A tiempo',
    },
  },
};

export default performanceDashboard;
